import { Navigate, Route, Routes } from "react-router-dom";
import { AppManagerLayout } from "./components/AppManagerLayout";
import { ClientLayout } from "./components/ClientLayout";
import { PlatformProtectedRoute } from "./components/PlatformProtectedRoute";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { SystemLayout } from "./components/SystemLayout";
import { ClientBookingPage } from "./pages/client/ClientBookingPage";
import { ClientConfirmPage, ClientManagePage } from "./pages/client/ClientActionPages";
import { BrandingStudioPage } from "./pages/manager/BrandingStudioPage";
import { ManagerAutomationPage } from "./pages/manager/ManagerAutomationPage";
import { ManagerCalendarPage } from "./pages/manager/ManagerCalendarPage";
import { ManagerClientsPage } from "./pages/manager/ManagerClientsPage";
import { ManagerBookPage } from "./pages/manager/ManagerBookPage";
import { ManagerDashboardPage } from "./pages/manager/ManagerDashboardPage";
import { ManagerIntegrationsPage } from "./pages/manager/ManagerIntegrationsPage";
import { ManagerInventoryPage } from "./pages/manager/ManagerInventoryPage";
import { ManagerServicesPage } from "./pages/manager/ManagerServicesPage";
import { ManagerSettingsPage } from "./pages/manager/ManagerSettingsPage";
import { ManagerStaffPage } from "./pages/manager/ManagerStaffPage";
import { SystemDashboardPage } from "./pages/system/SystemDashboardPage";
import { SystemTenantsPage } from "./pages/system/SystemTenantsPage";
import { SystemAbuseDashboardPage } from "./pages/system/SystemAbuseDashboardPage";
import { SystemAbuseLimitsPage } from "./pages/system/SystemAbuseLimitsPage";
import { SystemAbuseBlocklistPage } from "./pages/system/SystemAbuseBlocklistPage";
import { SystemCountryPresetsPage } from "./pages/system/SystemCountryPresetsPage";
import { SignupPortalPage } from "./pages/public/SignupPortalPage";
import { TelegramManagerEntryPage } from "./pages/telegram/TelegramManagerEntryPage";
import { TelegramSystemEntryPage } from "./pages/telegram/TelegramSystemEntryPage";
import { TelegramManagerQuickPage } from "./pages/telegram/TelegramManagerQuickPage";
import { TelegramOnboardingPage } from "./pages/telegram/TelegramOnboardingPage";
import { TelegramOwnerOnboardPage } from "./pages/telegram/TelegramOwnerOnboardPage";
import { TgLayout } from "./pages/telegram/TgLayout";
import { TgTodayPage } from "./pages/telegram/TgTodayPage";
import { TgCalendarPage } from "./pages/telegram/TgCalendarPage";
import { TgAppointmentPage } from "./pages/telegram/TgAppointmentPage";
import { TgReschedulePage } from "./pages/telegram/TgReschedulePage";
import { TgWaitlistPage } from "./pages/telegram/TgWaitlistPage";
import { TgClientsPage } from "./pages/telegram/TgClientsPage";
import { TgBookPage } from "./pages/telegram/TgBookPage";
import { TgDashboardPage } from "./pages/telegram/TgDashboardPage";
import { TgServicesPage } from "./pages/telegram/TgServicesPage";
import { TgStaffPage } from "./pages/telegram/TgStaffPage";
import { TgSettingsPage } from "./pages/telegram/TgSettingsPage";
import { TgIntegrationsPage } from "./pages/telegram/TgIntegrationsPage";
import { SystemLoginPage } from "./pages/SystemLoginPage";
import { TenantLoginPage } from "./pages/TenantLoginPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<TenantLoginPage />} />
      <Route path="/sys/login" element={<SystemLoginPage />} />
      <Route path="/signup" element={<SignupPortalPage />} />
      <Route path="/tg/manager" element={<TelegramManagerEntryPage />} />
      <Route path="/tg/system/login" element={<TelegramSystemEntryPage />} />
      <Route path="/tg/onboarding" element={<TelegramOnboardingPage />} />
      <Route path="/tg/onboard-owner" element={<TelegramOwnerOnboardPage />} />
      <Route
        path="/tg/manager/quick"
        element={
          <ProtectedRoute>
            <TelegramManagerQuickPage />
          </ProtectedRoute>
        }
      />

      {/* Telegram Mini App — expanded ops cockpit */}
      <Route
        path="/tg/system"
        element={
          <PlatformProtectedRoute redirectTo="/tg/system/login">
            <SystemLayout />
          </PlatformProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/tg/system/dashboard" replace />} />
        <Route path="dashboard" element={<SystemDashboardPage />} />
        <Route path="tenants" element={<SystemTenantsPage />} />
        <Route path="abuse/dashboard" element={<SystemAbuseDashboardPage />} />
        <Route path="abuse/limits" element={<SystemAbuseLimitsPage />} />
        <Route path="abuse/blocklist" element={<SystemAbuseBlocklistPage />} />
        <Route path="presets/countries" element={<SystemCountryPresetsPage />} />
      </Route>

      <Route
        path="/tg"
        element={
          <ProtectedRoute>
            <TgLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<TgDashboardPage />} />
        <Route path="dashboard" element={<TgDashboardPage />} />
        <Route path="today" element={<TgTodayPage />} />
        <Route path="calendar" element={<TgCalendarPage />} />
        <Route path="appointments/:id" element={<TgAppointmentPage />} />
        <Route path="reschedule/:id" element={<TgReschedulePage />} />
        <Route path="waitlist" element={<TgWaitlistPage />} />
        <Route path="clients" element={<TgClientsPage />} />
        <Route path="book" element={<TgBookPage />} />
        <Route path="services" element={<TgServicesPage />} />
        <Route path="staff" element={<TgStaffPage />} />
        <Route path="settings" element={<TgSettingsPage />} />
        <Route path="integrations" element={<TgIntegrationsPage />} />
      </Route>

      <Route path="/book/:tenantSlug/:branchSlug" element={<ClientLayout />}>
        <Route index element={<ClientBookingPage />} />
        <Route path="confirm/:token" element={<ClientConfirmPage />} />
        <Route path="manage/:token" element={<ClientManagePage />} />
      </Route>
      <Route path="/tg/client/book/:tenantSlug/:branchSlug" element={<ClientLayout />}>
        <Route index element={<ClientBookingPage />} />
        <Route path="confirm/:token" element={<ClientConfirmPage />} />
        <Route path="manage/:token" element={<ClientManagePage />} />
      </Route>

      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppManagerLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/app/dashboard" replace />} />
        <Route path="dashboard" element={<ManagerDashboardPage />} />
        <Route path="calendar/*" element={<ManagerCalendarPage />} />
        <Route path="clients/book" element={<ManagerBookPage />} />
        <Route path="clients" element={<ManagerClientsPage />} />
        <Route path="staff" element={<ManagerStaffPage />} />
        <Route path="services" element={<ManagerServicesPage />} />
        <Route path="inventory" element={<ManagerInventoryPage />} />
        <Route path="automation" element={<ManagerAutomationPage />} />
        <Route path="integrations" element={<ManagerIntegrationsPage />} />
        <Route path="branding" element={<BrandingStudioPage />} />
        <Route path="settings" element={<ManagerSettingsPage />} />
      </Route>

      <Route
        path="/sys"
        element={
          <PlatformProtectedRoute>
            <SystemLayout />
          </PlatformProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/sys/dashboard" replace />} />
        <Route path="dashboard" element={<SystemDashboardPage />} />
        <Route path="tenants" element={<SystemTenantsPage />} />
        <Route path="abuse/dashboard" element={<SystemAbuseDashboardPage />} />
        <Route path="abuse/limits" element={<SystemAbuseLimitsPage />} />
        <Route path="abuse/blocklist" element={<SystemAbuseBlocklistPage />} />
        <Route path="presets/countries" element={<SystemCountryPresetsPage />} />
      </Route>

      <Route path="/dashboard" element={<Navigate to="/app/dashboard" replace />} />
      <Route path="/calendar" element={<Navigate to="/app/calendar" replace />} />
      <Route path="/clients" element={<Navigate to="/app/clients" replace />} />
      <Route path="/staff" element={<Navigate to="/app/staff" replace />} />
      <Route path="/services" element={<Navigate to="/app/services" replace />} />
      <Route path="/inventory" element={<Navigate to="/app/inventory" replace />} />
      <Route path="/automation" element={<Navigate to="/app/automation" replace />} />
      <Route path="/integrations" element={<Navigate to="/app/integrations" replace />} />
      <Route path="/settings" element={<Navigate to="/app/settings" replace />} />
      <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
    </Routes>
  );
}
